import { TileLayer, WMSLayer } from "types/types";

export const overlayers: (WMSLayer | TileLayer)[] = [
  {
    id: 7,
    name: "Waterlopen",
    description:
      "<img src='resources/WaterlopenLegenda.png'> <br />Bron: <a href='https://inspirepub.waterinfo.be/arcgis/services/VHA_waterlopen/MapServer/WMSServer?request=GetCapabilities&service=WMS' target='_blank'>Vlaamse Milieumaatschappij</a><br />  <br />  <br /> <br /> <br /> <br /> ",
    wms: {
      url: "https://inspirepub.waterinfo.be/arcgis/services/VHA_waterlopen/MapServer/WmsServer?",
      layers: "4,3,2",
      opacity: 0.8,
      transparent: true,
      format: "image/png",
      tiled: true,
    },
    legend: false,
    default: false,
  },
  {
    id: 9,
    name: "Provinciegrenzen",
    description:
      "De provinciegrenzen van de provincies in het Vlaams gewest. <br><br>Bron:  <a href='http://www.geopunt.be/catalogus/datasetfolder/baebdc26-318e-4dea-aaf0-84229d2d6eeb' target='_blank'>agentschap Informatie Vlaanderen</a>",
    wms: {
      url: "/geoserver/effectenenimpacts/wms?",
      layers: "effectenenimpacts:provincie",
      opacity: 0.8,
      transparent: true,
      format: "image/png",
      tiled: true,
    },
    legend: false,
    default: false,
  },
  {
    id: 5,
    name: "Gemeentegrenzen",
    description:
      "De gemeentegrenzen van de gemeenten in het Vlaams gewest. <br><br>Bron:  <a href='http://www.geopunt.be/catalogus/datasetfolder/baebdc26-318e-4dea-aaf0-84229d2d6eeb' target='_blank'>agentschap Informatie Vlaanderen</a>",
    wms: {
      url: "/geoserver/effectenenimpacts/wms?",
      layers: "effectenenimpacts:gemeente",
      opacity: 0.8,
      transparent: true,
      format: "image/png",
      tiled: true,
    },
    legend: false,
    default: false,
  },
  {
    id: 6,
    name: "Statistische sectoren",
    description:
      "De statistische sectoren  (soms ook 'buurt' of 'wijk' genoemd) binnen het Vlaams gewest. <br /><br /> Bron: <a href='https://statbel.fgov.be/nl/over-statbel/methodologie/classificaties/statistische-sectoren' target='_blank'> het Belgische statistiekbureau</a>",
    wms: {
      url: "/geoserver/effectenenimpacts/wms?",
      layers: "effectenenimpacts:statsec",
      opacity: 0.8,
      transparent: true,
      format: "image/png",
      tiled: true,
    },
    legend: false,
    default: false,
  },
  {
    id: 12,
    name: "Kwetsbare ecotopen",
    description:
      "De contouren van alle ecotopen (weinig tot zeer) kwetsbaar voor verdroging, ook deze zonder droogtestress.",
    wms: {
      url: "/geoserver/effectenenimpacts/wms?",
      layers: "effectenenimpacts:ecotopen",
      opacity: 0.8,
      transparent: true,
      format: "image/png",
      tiled: true,
    },
    default: false,
    legend: false,
  },
  {
    id: 13,
    name: "Landbouwpercelen",
    description:
      "De contouren van alle landbouwgebruikspercelen, ook deze zonder droogtestress.",
    wms: {
      url: "/geoserver/effectenenimpacts/wms?",
      layers: "effectenenimpacts:landbouwpercelen",
      opacity: 0.8,
      transparent: true,
      format: "image/png",
    },
    default: false,
    legend: false,
  },
];

export const backgroundLayers: (WMSLayer | TileLayer)[] = [
  {
    id: 11,
    name: "VMM Basiskaart",
    description:
      "Basis achtergrondkaart Klimaatportaal<br><br>Bron: Vlaamse Milieumaatschappij",
    url: "https://inspirepub.waterinfo.be/arcgis/rest/services/klimaatportaal/achtergrond_KP/MapServer/WMTS/tile/1.0.0/klimaatportaal_achtergrond_KP/default/default028mm/{z}/{y}/{x}.png",
    nativeZoom: 18,
    default: false,
  },
  {
    id: 8,
    name: "Digitaal hoogtemodel",
    description: "Dogitaal hoogtemodel<br><br>Bron: geoservices.be",
    wms: {
      url: "https://geo.api.vlaanderen.be/DHMV/wms",
      layers: "DHMVII_DTM_1m",
      opacity: 0.8,
      transparent: true,
      format: "image/png",
      tiled: true,
    },
    legend: false,
    default: false,
  },
  {
    id: 2,
    name: "GRB Basiskaart grijswaarden",
    description:
      "Het Grootschalig Referentiebestand (GRB) van Vlaanderen (in grijswaarden).<br><br> Bron: <a href='http://www.geopunt.be/catalogus/webservicefolder/1c48cce2-5ef1-38bc-0904-92e2-2d43-1e1b-c46328b2' target='_blank'>agentschap Informatie Vlaanderen</a>",
    url: "https://geo.api.vlaanderen.be/GRB/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=grb_bsk_grijs&STYLE=&FORMAT=image/png&TILEMATRIXSET=GoogleMapsVL&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}",
    nativeZoom: 21,
    default: true,
  },
  {
    id: 3,
    name: "Luchtfoto winter",
    description:
      "Luchtfoto van Vlaanderen, winteropname 2019. <br><br>Bron:  <a href='https://www.vlaanderen.be/datavindplaats/catalogus/orthofotomozaiek-middenschalig-winteropnamen-kleur-2019-vlaanderen' target='_blank'>agentschap Informatie Vlaanderen</a>",
    url: "https://geo.api.vlaanderen.be/OMW/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=omwrgb19vl&STYLE=&FORMAT=image/png&TILEMATRIXSET=GoogleMapsVL&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}",
    nativeZoom: 21,
    default: false,
  },
  {
    id: 4,
    name: "Luchtfoto zomer",
    description:
      "Luchtfoto van Vlaanderen, zomeropname 2018. <br><br> Bron: <a href='https://www.vlaanderen.be/datavindplaats/catalogus/orthofotomozaiek-middenschalig-zomeropnamen-2018-vlaanderen' target='_blank'> agentschap Informatie Vlaanderen</a>",
    url: "https://geo.api.vlaanderen.be/OMZ/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=omzrgb18vl&STYLE=&FORMAT=image/png&TILEMATRIXSET=GoogleMapsVL&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}",
    nativeZoom: 21,
    default: false,
  },
  {
    id: 1,
    name: "Open street map",
    description:
      "OpenStreetMap, een vrij beschikbare kaart op basis van open source en crowd sourcing. ",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    nativeZoom: 19,
    default: false,
  },
  {
    id: 14,
    name: "Bodembedekking 2018",
    description: "todo",
    attribution: "BBK: Digitaal Vlaanderen, 2021",
    wms: {
      url: "/geoserver/wms",
      layers: "projecttool_landuse_v1",
      opacity: 0.8,
      transparent: true,
      format: "image/png",

      tiled: true,
    },
    legend: true,
    default: false,
  },
];
